// context/AppProviders.js
import React from "react";
import { AlertsProvider } from "./AlertsContext";
import { LoaderProvider } from "./LoaderContext";
import { DialogProvider } from "./DialogContext";

/**
 * AppProviders
 * -------------
 * A wrapper component to include all global context providers in a single place.
 * 
 * Usage:
 * Wrap your <App /> with <AppProviders> in index.js so all components can access
 * alerts, loader, and dialog contexts.
 * 
 * Example:
 * <AppProviders>
 *   <App />
 * </AppProviders>
 * 
 * Providers included:
 * - AlertsProvider : For showing toast/alerts
 * - LoaderProvider : For showing a global loader/spinner
 * - DialogProvider : For showing modals/dialogs (error, info, confirm)
 *
 * @param {React.ReactNode} children - The components that need access to these contexts
 */
export const AppProviders = ({ children }) => (
  <AlertsProvider>
    <LoaderProvider>
      <DialogProvider>
          {children}
      </DialogProvider>
    </LoaderProvider>
  </AlertsProvider>
);
